import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwTextField";

/**
 * VuwPasswordField (extends VuwTextField)
 * @options
 * - {Boolean} required
 * - {Number} ltd
 * - {Number} min
 */
vuwer.appendKlass("VuwPasswordField", {
	inpType: "password",
	inpClassList: ["inp", "inp-txt", "inp-pass"],
	
	_initialize(opt) {
		if( Klass("VuwPasswordField").parent._initialize.call(this, opt) ) {
			this.placeholder = 0;
			
			// [バリデーションの登録]
			// ltdの上書き
			this._validations.ltd = function(val) {
				return !u_.isNumber(this.ltd) || val <= this.ltd;
			};
			
			// 文字数制限
			this.addValidation("min", function(val) {
				return !u_.isNumber(this.min) || val >= this.min;
			}, this.min ? String(this.min) + "文字以上にして下さい" : "");
			
			// [min の動的な切り替え用]
			this.onChangeState(function(state) {
				if(this.$inp.length && state.hasOwnProperty("min") ) {
					if( u_.isNumber(state.min) && state.min > 0) {
						this.min = state.min;
						this.errorMessages.min = String(this.min) + "文字以上にして下さい";
					}
					delete state.min;
				}
			});
			
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady($self) {
		Klass("VuwPasswordField").parent.getInpReady.call(this, $self);
		return this;
	},
	
	setVal(value, antiTriggerChange) {
		var doTrigger = (this.$inp.length && !antiTriggerChange);
		
		if( u_.isString(value) ) {
			if(!value) {	// ** for IE **
				const currentVal = this.getVal();
				if( u_.isNumber(currentVal) ) {
					return this;
				}
			}
			
			doTrigger && this.$inp.val(value);
			value = value.length;
		} else
		if( u_.isNumber(value) ) {
			doTrigger && this.$inp.attr( "placeholder", this.hideText(value) ).val("");
		} else {
			doTrigger && this.$inp.attr("placeholder", "").val("");
			value = 0;
		}
		
		Klass("VuwField").prototype.setVal.call(this, value);
		
		doTrigger && this.$inp.trigger("change", [true]);
		return this;
	},
	
	_getCopiedInp(val) {
		var clones = [];
		
		(val === undefined) && ( val = this.getVal() );
		
		if( u_.isNumber(val) ) {
			clones.push( $("<span/>").addClass("replaced-inp").text(
				this.hideText(val) || this.$inp.attr("placeholder")
			) );
		}
		return clones;
	},
	
	_renderField() {
		var
			attr = {
				type: "password",
				name: this.paramKey,
				id: ["inp", this.idStr].join("_"),
				autocomplete: this.autocomplete || "on"
			},
			elms = [];
		
		elms.push( $("<input/>").addClass( this.inpClassList.join(" ") ).attr(attr) );
		return $.fn.append.apply(
			$("<fieldset/>").addClass("vuw-field field-pass").attr({
				"id": ["field", this.idStr].join("_"),
				"data-name": this.paramKey
			}),
			elms
		);
	},
	
	hideText(len, char) {
		var rtn, i;
		
		if( !u_.isInteger(len) ) {
			throw new TypeError("argument[0] must be integer.");
		}
		
		(u_.isString(char) && char.length === 1) || (char = "･");
		
		rtn = "";
		for(i = 0; i < len; i++) {
			rtn += char;
		}
		return rtn;
	}
}, "VuwTextField");

